var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`file-drop ${this.visible ? '' : 'hidden'}`,on:{"dragenter":_vm.handleDragEnter,"dragleave":_vm.handleDragLeave,"dragover":_vm.handleDragOver,"drop":_vm.handleDrop}})
}
var staticRenderFns = []

export { render, staticRenderFns }